import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AppService } from '../shared/services/app.service';
import { AuthService } from '../shared/services/auth.service';
import { NotifyService } from '../shared/services/notify.service';

import { INotification } from '../shared/interfaces/notification';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  form: FormGroup;

  constructor(
      @Inject(FormBuilder) fb: FormBuilder,
      private _appService: AppService,
      private _authService: AuthService,
      private _notifyService: NotifyService,
      private _router: Router
    ) {
    this.form = fb.group({
      username: [null, Validators.required],
      password: [null, Validators.required]
    });
  }

  ngOnInit() {
    // this._appService.setbgClass('black');
    this._appService.hideLoader();
    this._appService.hideNav();
  }

  login() {

    let f = this.form;
    this._appService.showLoader();

    this._authService.loginUser(f.get('username').value, f.get('password').value).subscribe(
      data => {
        this.cancel();
        // this._notifyService.setNote({
        //   styleClass: 'alert-success',
        //   heading: 'Success!',
        //   body: 'Logging In . . .'
        // });
        if(data.user.role == 'Non-Staff'){
          this._router.navigate(['remnants']);
        } else {
          this._router.navigate(['welcome']);
        }

      },
      error => {
        this.cancel();
        this._appService.hideLoader();
        this._notifyService.setNote({
          styleClass: 'alert-danger',
          heading: 'Login Failed',
          body: 'The username or password did not match the system.'
        });
      }
    );
  }

  cancel() {
    this.form.reset();
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts